import React, { useEffect, useState } from "react";

import Space from "../../layout/Space";
import PrimaryButton from "../../buttons/PrimaryButton";

import { logoutUser, useAuth } from "../../auth/FirebaseAuth";

import { useSnackbar } from "notistack";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import Modal1 from "../../modals/Modal1.js";
import SecondaryButton from "../../buttons/SecondaryButton";

import { useAppContext } from "../../config/AppContext";

import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";

import TextField2T from "../../textfields/TextField2T";
import { File, Org, User } from "../../types/basicTypes";
import updateDocApi from "../../api/database/updateDocApi";
import uploadFiles from "../../api/upload/uploadFiles";

// Account Component
type AccountProps = {
  userData: User;
  orgData: Org;
  navigateWorkspace: (path: string) => void;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
};

function Account({
  userData,
  orgData,
  navigateWorkspace,
  handleClickVariant,
}: AccountProps) {
  const { currentUser, loading } = useAuth();

  const [nom, setNom] = useState("");
  const [email, setEmail] = useState("Email");
  const [phone_number, setPhoneNumber] = useState("");

  const [token, setToken] = useState(null); // Store the token here

  const { appState, setAppState, resetAppStateLogin } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const fetchData = async () => {
    if (userData) {
      try {
        setToken(token);
        setNom(userData.display_name || "");
        setEmail(userData.email || "Email");
        setPhoneNumber(userData.phone_number || "");
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };

  const [image, setImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [smsOpen, setSmsOpen] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);

  const handleChangeLogo = async () => {
    const token = await getOrRefreshFirebaseToken();

    // make the user select a pdfr
    if (loadingFile) {
      return;
    }
    const input = document.createElement("input");
    input.type = "file"; // pdf
    input.accept = "image/*"; // accept only images
    input.onchange = (event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        setLoadingFile(true);
        const reader = new FileReader();
        reader.onload = async (e) => {
          const newCertificat: File = {
            url: e.target?.result as string,
            name: file.name,
            id: `none`,
            octets: file.size,
          };
          let file_id = "orgs/" + orgData.id + "/signatures/" + file.name;
          const token = await getOrRefreshFirebaseToken();
          let fresh_files = await uploadFiles(
            [newCertificat],
            file_id,
            "logo",
            token,
            prefix
          );
          if (fresh_files && fresh_files.files.length > 0) {
            await updateDocDataFieldApi(
              userData.ref!,
              "signature_url",
              fresh_files.files[0].url,
              prefix
            );
            // await uploadImage(orgData.id, token, prefix);

            setLoadingFile(false);
          }
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();

    handleClickVariant("Logo modifié avec succès", "success");
    // I want the whole app to refresh
  };

  // Fetch the token asynchronously using useEffect
  useEffect(() => {
    fetchData(); // Call the function
  }, [currentUser]); // Run this effect only when currentUser changes

  const callModifyUser = async () => {
    try {
      const token = await getOrRefreshFirebaseToken();
      await updateDocApi(
        "user",
        userData.id,
        {
          display_name: nom,
          phone_number: phone_number,
        },
        prefix
      );
      handleClickVariant("Utilisateur modifié avec succès", "success");
    } catch (error) {
      console.error("Error modifying user:", error);
      handleClickVariant(
        "Erreur lors de la modification de l'utilisateur",
        "error"
      );
    }
  };

  const handleSendVerificationEmail = async () => {
    try {
      // const token = await getOrRefreshFirebaseToken();
      // await sendVerificationEmail(token, prefix);
      handleClickVariant("Email de vérification envoyé", "success");
    } catch (error) {
      console.error("Error sending verification email:", error);
      handleClickVariant("Erreur lors de l'envoi de l'email", "error");
    }
  };

  if (!userData) {
    return <div></div>;
  }
  return (
    <div className="flex flex-row gap-1 w-full h-full overflow-auto pb-20">
      <div className="flex flex-col  h-full max-w-c500 pl-4 ">
        <div className="flex flex-row justify-between w-full">
          <div className="text-h1 font-bold text-left">Compte</div>{" "}
          <div className="text-h5 text-shadow_10">user_id {userData.id}</div>
        </div>

        <Space y={20} />

        <div className="flex  w-full text-h2 font-normal">
          <SecondaryButton onClick={handleSendVerificationEmail}>
            Envoyer un email de vérification
          </SecondaryButton>
        </div>
        <Space y={10} />
        <div className="flex  w-full text-h2 font-normal">
          <SecondaryButton
            // onClick={handleSendPasswordResetEmail}
            className="w-fit"
          >
            Envoyer un mail de réinitialisation de mot de passe
          </SecondaryButton>
        </div>
        <Space y={30} />
        <div className="flex flex-col gap-1 w-full pr-2">
          <TextField2T
            className="w-full"
            label="ID"
            value={userData.id}
            disabled={true}
          />
          <TextField2T
            className="w-full"
            label="Email"
            value={userData.email}
            disabled={true}
          />
          <TextField2T
            className="w-full"
            label="Prénom Nom"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
          />

          <TextField2T
            className="w-full"
            label="Numéro de téléphone"
            value={phone_number}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
        </div>
        <Space y={5} />
        <div className="flex flex-col gap-1 w-full pr-2">
          <div className="flex justify-end w-full text-h2 font-normal">
            <PrimaryButton
              onClick={callModifyUser}
              disabled={userData?.display_name === nom}
            >
              Enregistrer
            </PrimaryButton>
          </div>
        </div>
        <Space y={10} />
      </div>
    </div>
  );
}

export default Account;
